import APIconsume from 'Main/APIconsume'

class DashboardService {
  constructor () {
    this._apiConsume = new APIconsume()
  }

  async getStats ({ from = '', to = '' } = {}) {
    const params = new URLSearchParams()
    if (from) params.set('from', from)
    if (to) params.set('to', to)
    const query = params.toString()
    const result = await this._apiConsume.getData(`/api/dashboard${query ? `?${query}` : ''}`)
    return result?.data
  }
}

export default DashboardService
